import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {
    makeRequest,
    dispatchAction,
    displayMessage
} from 'actions';
import moment from 'moment'
import json2csv   from 'json2csv'

import {onRowSelect,onAllRowSelect,customMultiSelect} from 'util/Utils';

import {Row, Col, Form, FormGroup, Checkbox, Modal, ControlLabel, FormControl, Button} from 'react-bootstrap';
import Select   from 'react-select'
import {   FETCH_ALL_SELLERS_LIST} from "actions/actionTypes";
import formatNumbers  from 'util/formatNumbers';

import queryString from 'query-string'
import PaginationBox from'shared/PaginationBox';
import {prepareSelectOptionsList} from 'util/Utils';
import AdminInventoryReconActionsBox from 'dashboard/inventoryRecon/AdminInventoryReconActionsBox'

import AdminInventoryReconListTable from 'dashboard/inventoryRecon/AdminInventoryReconListTable';
import AdminInventoryReconSearchBox from 'dashboard/inventoryRecon/AdminInventoryReconSearchBox'
import Datetime from 'react-datetime'
  import config from  '../../../config';



class AdminInventoryReconPage extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props, context) {
        super(props, context);
        this.state = {
             showModal: false,
            errors: {},
            sortBy: '',
            selectAllRecords: false,
             currentRecord:{},
            currentPage: _.isUndefined(this.props.location.query.page) ? 0 : parseInt(this.props.location.query.page) - 1,
            recordIDs:[],
            sellersOptionsList:prepareSelectOptionsList(this.props.allSellersList.data, {
                label: 'DisplayName',
                value: '_id'
            }),
            adminInventoryRecon:{
                 data: [],
                fetched:false,
                total:0
            }
        };
        this.searchBox = null

    };
    componentWillMount() {

        var self = this;

        if (_.size(self.props.allSellersList.data) == 0) {
            var methodData = {
                "success_event": FETCH_ALL_SELLERS_LIST,
                "endpoint": "/sellers",
                'not_display_success_message': true
            };
            this.props.makeRequest({sortBy:'DisplayName:1',all:true, include:['DisplayName','InventoryOwnership']}, methodData).catch(err => {
            });
        }
    }
    componentWillReceiveProps(nextProps) {
        if (_.size(nextProps.allSellersList.data) !== _.size(this.props.allSellersList.data)) {
            this.setState({sellersOptionsList :prepareSelectOptionsList(nextProps.allSellersList.data, {
                label: 'DisplayName',
                value: '_id'
            })})
        }
    }


    editRecord(row) {
        var recordCopy = _.cloneDeep(row)
        if (_.includes( row.Name,'ServiceDateRules')   ) {
            recordCopy.PickupDateRules =_.orderBy(
              _.map(_.get(recordCopy, ['Data', 'Pickup', 'Rules'], []), item=>{
                 return {value:moment(item.Date).format('MM-DD-YYYY'), label: moment(item.Date).format('MM-DD-YYYY')}
            }),  item=>{
                    return item.label
                },[  'asc'])
            recordCopy.DropoffDateRules =_.orderBy(
                _.map(_.get(recordCopy, ['Data', 'Dropoff', 'Rules'], []), item=>{
                    return {value:moment(item.Date).format('MM-DD-YYYY'), label: moment(item.Date).format('MM-DD-YYYY')}
                }),  item=>{
                    return item.label
                },[  'asc'])
        }
         this.setState({
            showModal: true,
            currentRecord: recordCopy,
        });
    }

    closeModal() {
        this.setState({
            showModal: false,
            currentRecord: {},
        });
    }





    validateAndGetFormData() {

        var formData = {fieldsToUpdate:[]},            dataNotValid = false;
        if (_.includes( this.state.currentRecord.Name,'ServiceDateRules')   ) {
            formData.fieldsToUpdate.push({
                path:['Pickup','Rules'],
                value:_.map(this.state.currentRecord.PickupDateRules, date=>{
                    return {Date:moment.utc(date.value, 'MM-DD-YYYY').set('hour', 12)   }
                })
            })
            formData.fieldsToUpdate.push({
                path:['Dropoff','Rules'],
                value:_.map(this.state.currentRecord.DropoffDateRules, date=>{
                    return {Date:moment.utc(date.value, 'MM-DD-YYYY').set('hour', 12)   }
                })
            })
        }



         console.log('formData', dataNotValid, formData);
        if (dataNotValid) {
            return false;
        }
        return formData
    }

    saveRecord() {
        var self = this;
        this.setState({pending: true});
        var formData = this.validateAndGetFormData();
        if (!formData) {
            this.setState({pending: false});
            return false;
        }
        var methodData = {
            "endpoint": "/inventoryRecon/" + encodeURIComponent(this.state.currentRecord._id),
            type: "patch",
        };

        self.props.makeRequest(formData, methodData).then(recordUpdateResponse => {
            self.setState({pending: false});

            self.search()
            self.closeModal()
        }).catch(err => {
            self.setState({pending: false});
        });
    }


    onSortChange(field, sort) {
        console.log('field', field);
        this.setState({sortBy: field + ':' + (sort == 'asc' ? 1 : -1)}, function () {
            this.refs.pagination.resetPagination();
            this.search()
        })
    }
    downloadReport(params) {
        var self = this;
        this.setState({pending:true})
        var {queryParams} = this.searchBox.getSearchParams();
        var methodData = {
            "endpoint": "/create-report",
            'type': 'post',
            'not_display_success_message': true,
            overrideServerBaseURL: config.getEnvironment().directServerBaseURL,
        };

        var fieldsToAdd =_.intersection( [
            'ProductsTotalNumber',
            'ProductsTotalSum',
            'ProductsTotalCOGS',
            'SaleTransactionsTotalNumber',
            'SaleTransactionsTotalSum','PendingSaleTransactionsTotalSum',
            'PendingSaleTransactionsTotalProductCOGS','SoldSaleTransactionsTotalProductCOGS'
        ], _.map(params.reportFields,'value'))
        if (_.size(this.state.recordIDs)==0){
            this.setState({pending:false})
            return this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Records for report not selected'
            });
        }
        this.props.makeRequest(_.extend({
            addFields : fieldsToAdd,
            'sellers': this.state.recordIDs,
            all:true,
            sortBy: 'DisplayName' + ':' + (-1),
            reportType: 'inventoryRecon',
        },queryParams), methodData).then(res => {
            var fields = _.map(params.reportFields, function (field) {
                return _.extend({}, field, {default: ''});
            })

            var dataToExport  = []
            _.forEach(res.data.data, function (record) {


                record.ProductsTotalCOGS =    formatNumbers.toFixed( record.ProductsTotalCOGS, 2)
                record.PendingSaleTransactionsTotalProductCOGS =    formatNumbers.toFixed( record.PendingSaleTransactionsTotalProductCOGS, 2)
                record.SoldSaleTransactionsTotalProductCOGS =    formatNumbers.toFixed( record.SoldSaleTransactionsTotalProductCOGS, 2)
                record.SaleTransactionsTotalSum =    formatNumbers.toFixed( record.SaleTransactionsTotalSum, 2)
                record.PendingSaleTransactionsTotalSum =    formatNumbers.toFixed( record.PendingSaleTransactionsTotalSum, 2)
                record.SaleTransactionsTotalNumber = _.size(_.filter(_.get(record,  'SellerSaleTransactions',[]), (item)=>{
                    return item._id
                }))
                var customData = { };
                dataToExport.push({...record,...customData})

            })
            var csvData = json2csv.parse(dataToExport, {
                fields: fields,
            })

            var filename = "inventory_recon_report_" + moment().format("YYYY-MM-DD-HH-mm") + ".csv";
            var blob = new Blob([csvData], {type: 'text/csv;charset=utf-8;'});
            if (navigator.msSaveBlob) { // IE 10+
                navigator.msSaveBlob(blob, filename);
            } else {
                var link = document.createElement("a");
                if (link.download !== undefined) { // feature detection
                    // Browsers that support HTML5 download attribute
                    var url = URL.createObjectURL(blob);
                    link.setAttribute("href", url);
                    link.setAttribute("download", filename);
                    link.style.visibility = 'hidden';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            }
            self.setState({pending:false})
        }).catch(err => {
            self.setState({pending:false})
            console.log('err', err);
        });
    }
    search(params = {}) {
        if (this.state.pending){
            return this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Please wait till search request is completed'
            });
        }
        this.setState({pending:true})
         if (this.searchBox) {
            var {queryParams} = this.searchBox.getSearchParams();
        } else {
            var queryParams = {}
        }
        _.extend(queryParams, params);
        queryParams.addFields = [
           'ProductsTotalNumber',
           'ProductsTotalSum',
            'ProductsTotalCOGS',
         'SaleTransactionsTotalNumber',
         'SaleTransactionsTotalSum',
            'PendingSaleTransactionsTotalSum',
         'PendingSaleTransactionsTotalProductCOGS','SoldSaleTransactionsTotalProductCOGS',

         ]
        queryParams.InventoryOwnership = ['PartnerPurchased']
        if (this.state.sortBy) {
            queryParams.sortBy = this.state.sortBy;
        } else {
            queryParams.sortBy = 'DisplayName' + ':' + (-1);
        }
        if(queryParams.all){
            delete queryParams.addFields
        }
        if (queryParams.page === 1) {
            delete queryParams.page;
        }
        if (_.isUndefined(queryParams.page)) { /* do not clear selected records when only pagination is changed */
          //  this.setState({recordIDs:[]})
        }
        var methodData = {
            "endpoint": "/create-report",
            'type':'post',
            'not_display_success_message':true,
            overrideServerBaseURL: config.getEnvironment().directServerBaseURL,
         };

        if (_.isUndefined(params.doNotUpdateUrlString)) {
            const stringified = queryString.stringify(_.omit(queryParams, ['include', 'InventoryOwnership','lookup', 'all','addFields' ]));
             this.context.router.push('/admin/inventory-recon?' + stringified);
        }

        queryParams.reportType = 'inventoryRecon'
        return this.props.makeRequest(queryParams, methodData).then(res => {
            this.setState({pending:false})
            if (this.refs.pagination && _.isUndefined(queryParams.page)) {
                this.refs.pagination.resetPagination();
            }
            if (queryParams.all){
                return res
            }
            //  _.forEach(res.data.data, item=>{
            //     _.forEach(_.get(item, 'SellerProductsListed',[]),product=>{
            //         //console.log('product.ShopifyProductID', product.ShopifyProductID  );
            //     })
            // })
           this.setState({
              adminInventoryRecon:{
                data:res.data.data,
                  total:res.data.total,
                  fetched:true,
            }})



        }).catch(err => {
            this.setState({pending:false})
        });
    }

    toggleAllRecordsSelection(value) {
        if (this.state.selectAllRecords) {
            this.setState({recordIDs: [], selectAllRecords: false});
        }else {
            this.search({include: ['_id'], all: true}).then(response => {
console.log('response.data', response.data  );
                this.setState({recordIDs: _.map(response.data.data, '_id'), selectAllRecords: true});
            })
        }
    }

    render() {
        console.log('AdminInventoryReconPage this state', this.state);
        if (!_.size(this.state.sellersOptionsList)){
            return null
        }
         return (
            <div style={{position:'relative'}} >
                {config.checkAccessRights.call(this, {resources: ['inventory_recon_full']}) &&
                <AdminInventoryReconActionsBox
                    downloadReport={this.downloadReport.bind(this)}
                    search={this.search.bind(this)}
                    {...this.props} ></AdminInventoryReconActionsBox>
                }
                <AdminInventoryReconSearchBox
                    ref={(searchBox) => {
                        if (searchBox && !this.searchBox) {
                            this.searchBox = searchBox;
                            this.search({page:this.state.currentPage+1})
                        }
                    } }
                    sellersOptionsList={ this.state.sellersOptionsList}
                    selectAllRecords = {this.state.selectAllRecords}
                    toggleAllRecordsSelection = {this.toggleAllRecordsSelection.bind(this)}
                    search={this.search.bind(this)}
                    {...this.props} ></AdminInventoryReconSearchBox>

                <div className="clearfix"></div>
                {this.state.adminInventoryRecon.fetched &&
                <div className="">
                    {this.state.adminInventoryRecon.total == 0 ?
                        <div
                            className="messageBox">{config.clientMessages.noRecordsFoundForCriteria.replace("#1#", 'records')}</div> :
                        <div className="top10">

                            <AdminInventoryReconListTable
                                ref="table"
                                tableData={_.map(this.state.adminInventoryRecon.data, item=>{
                                 return {...item,_id:item._id._id}
                                })}
                                onSortChange={this.onSortChange.bind(this)}
                                onRowSelect ={onRowSelect.bind(this)}
                                onAllRowSelect ={onAllRowSelect.bind(this)}
                                customMultiSelect ={customMultiSelect.bind(this)}
                                search={this.search.bind(this)} {...this.props}  ></AdminInventoryReconListTable>
                            <PaginationBox
                                currentPage={_.isUndefined(queryString.parse(this.props.location.search).page) ? 0 : parseInt(queryString.parse(this.props.location.search).page) - 1}
                                perPage={this.searchBox ? this.searchBox.state.filterOptions.perPage : _.get(queryString.parse(this.props.location.search), ['perPage'], undefined)}
                                ref={'pagination'}
                                total={  this.state.adminInventoryRecon.total}
                                search={this.search.bind(this)}>
                            </PaginationBox>

                        </div>}
                </div>
                }

                <Modal onExited={this.closeModal.bind(this)} show={this.state.showModal}
                       onHide={(e) => this.setState({showModal: false})}>
                    <Modal.Header closeButton>
                        <Modal.Title>{  'Edit'  }</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            { _.includes( this.state.currentRecord.Name,'ServiceDateRules')&& this.displayDateSelectionInput()}

                        </Form>
                    </Modal.Body>
                    <Modal.Footer className="top20">
                        <Row className="left0">
                            <Col md={12} sm={12} xs={12} className="pleft0">
                                <Button className=" right0 pull-right btn btn-primary "
                                        disabled={this.state.pending}
                                        type="button"
                                        onClick={this.saveRecord.bind(this) }>
                                    Save
                                </Button>
                                <Button className="pull-right btn right20 btn-default" type="button"
                                        onClick={(e) => this.closeModal() }>
                                    Cancel
                                </Button>
                            </Col>
                        </Row>
                    </Modal.Footer>
                </Modal>
                {this.state.pending &&
                <div className="pending-box"></div>
                }

            </div >
        );

    }
}

function mapStateToProps(state, props) {
    return {
        userReducer: state.userReducer,
        allSellersList: state.allSellersList
      };
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({makeRequest, dispatchAction, displayMessage}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminInventoryReconPage);
